/**
 * @param {string | Element} elm CSS selector, hash (e.g. "#6", "#tbox1"), or element
 * @returns {Element | null}
 */
function resolveScrollTarget(elm) {
  if (elm instanceof Element) {
    return elm;
  }

  if (typeof elm !== 'string') {
    return null;
  }

  if (elm.startsWith('#')) {
    const id = decodeURIComponent(elm.slice(1));

    if (id) {
      const byId = document.getElementById(id);

      if (byId) {
        return byId;
      }

      const namedAnchor = document.querySelector(`a[name="${CSS.escape(id)}"]`);

      if (namedAnchor) {
        return namedAnchor;
      }
    }
  }

  try {
    return document.querySelector(elm);
  } catch {
    return null;
  }
}

/**
 * @param {string | Element} elm
 * @param {number} [extraOffset]
 * @param {string} [header]
 * @param {number} [attempt]
 * @param {{ preferHeaderOffset?: boolean }} [options]
 */
export const scrollToPosition = (elm, extraOffset = 0, header = '', attempt = 0, options = {}) => {
  const element = resolveScrollTarget(elm);

  if (!element) {
    if (attempt < 4 && typeof elm === 'string' && elm.startsWith('#')) {
      window.requestAnimationFrame(() => {
        scrollToPosition(elm, extraOffset, header, attempt + 1, options);
      });
    }

    return;
  }

  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

  const headerEl = header ? document.querySelector(header) : document.querySelector('.c-header') ?? document.querySelector('.js-header');

  const headerOffset = headerEl ? headerEl.offsetHeight : 0;
  const scrollMarginTop = Number.parseFloat(getComputedStyle(element).scrollMarginTop) || 0;

  let clearance;
  if (options.preferHeaderOffset) {
    clearance = headerOffset;
  } else {
    // scroll-margin-top already reserves fixed-header clearance — use the larger of the two, not both
    clearance = Math.max(scrollMarginTop, headerOffset);
  }

  const offsetPosition = elementPosition - clearance - extraOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
